import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type AlertType = 'success' | 'info' | 'warning' | 'error';
export interface IAlertState {
    alertOpen: boolean;
    alertType: AlertType;
    alertText: string;
}

const initialState: IAlertState = {
    alertOpen: false,
    alertType: "success",
    alertText: "",
};

export const alertSlice = createSlice({
    name: 'alert',
    initialState: initialState,
    reducers: {
        setAlert: (state: IAlertState, action: PayloadAction<IAlertState>) => {
            const {alertOpen, alertType, alertText} = action.payload;

            return {
                ...state,
                alertOpen: alertOpen,
                alertType: alertType,
                alertText: alertText
            };
        },
    },
});

export const {setAlert} = alertSlice.actions;
